import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    deliveryOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    deliveryInnerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '879px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        height: '1650px',
        flexDirection: 'column-reverse',
        justifyContent: 'flex-end'
      },
      [theme.breakpoints.only('lg')]: {
        height: '830px'
      }
    },
    deliveryComponentContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '100%',
      background: 'transparent'
    },
    deliveryTextContainer: {
      display: 'flex',
      padding: '0 70px',
      alignItems: 'center',
      justifyContent: 'center',
      borderRight: '1px solid #D8D8D8',
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%',
        padding: '114px 0px 56px 29px',
        borderRight: 'none',
        alignItems: 'flex-start'
      }
    },
    deliveryImageContainer: {
      [theme.breakpoints.down('lg')]: {
        height: '53%'
      },
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%'
      },
      '& > * ': {
        [theme.breakpoints.only('lg')]: {
          padding: '0px 0px 90px 0px'
        }
      }
    },
    deliveryPrintingText: {
      width: '660px',
      margin: '0px 0px 56px 0px',
      background: 'transparent',
      textAlign: 'center',
      [theme.breakpoints.only('lg')]: {
        width: '550px'
      }
    },
    deliveryPrintingHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      background: 'transparent',
      padding: '0px 16px 0px 16px',
      margin: '0px 0px 48px 0px',
      '& > *': {
        [theme.breakpoints.only('lg')]: {
          width: '550px'
        }
      }
    }
  })
);
